import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  unreadCount: 0,
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action) => {
      const incomingId = action.payload?._id;
      if (incomingId && state.notifications.some((item) => item._id === incomingId)) {
        return;
      }

      state.notifications.unshift(action.payload);
      state.totalCount += 1;
      state.totalPages = Math.max(1, Math.ceil(state.totalCount / 10));
      if (!action.payload.isRead) {
        state.unreadCount += 1;
      }
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload.notifications || [];
      state.unreadCount = action.payload.unreadCount || 0;
      state.currentPage = action.payload.currentPage || 1;
      state.totalPages = action.payload.totalPages || 1;
      state.totalCount = action.payload.totalCount || state.notifications.length;
    },
    appendNotifications: (state, action) => {
      const existingIds = new Set(state.notifications.map((item) => item._id).filter(Boolean));
      const nextNotifications = (action.payload.notifications || []).filter(
        (item) => !item._id || !existingIds.has(item._id)
      );
      state.notifications = [...state.notifications, ...nextNotifications];
      state.unreadCount = action.payload.unreadCount ?? state.unreadCount;
      state.currentPage = action.payload.currentPage || state.currentPage;
      state.totalPages = action.payload.totalPages || state.totalPages;
      state.totalCount = action.payload.totalCount ?? state.totalCount;
    },
    markReadInState: (state, action) => {
      const notification = state.notifications.find((item) => item._id === action.payload);
      if (notification && !notification.isRead) {
        notification.isRead = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllReadInState: (state) => {
      state.notifications = state.notifications.map((item) => ({ ...item, isRead: true }));
      state.unreadCount = 0;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.unreadCount = 0;
      state.currentPage = 1;
      state.totalPages = 1;
      state.totalCount = 0;
    },
  },
});

export const {
  addNotification,
  appendNotifications,
  setNotifications,
  markReadInState,
  markAllReadInState,
  clearNotifications,
} = notificationSlice.actions;
export default notificationSlice.reducer;
